import { handleUploadPhotos } from '~/utils/api';
import { b64toBlob } from '~/utils/base64ToBlob';

export const reuploadImg = async (photo, config) => {
  return handleUploadPhotos(
    photo.sessionKey,
    b64toBlob(photo.base64),
    photo.photoCode,
    config
  );
};
